/** Normalizes backend datetime strings for JS Date parsing (e.g. space before timezone offset). */
export const normalizeAppointmentDateTime = (isoStr: string): string => (
  isoStr.trim().replace(/(\d)\s+([+-]\d{2}:?\d{2})$/, '$1$2')
);

export const parseAppointmentDateTime = (isoStr: string): Date | null => {
  if (!isoStr.trim()) return null;
  const date = new Date(normalizeAppointmentDateTime(isoStr));
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatAppointmentWhen = (isoStr: string): string => {
  const date = parseAppointmentDateTime(isoStr);
  if (!date) return '—';

  const datePart = date.toLocaleDateString('en-AU', {
    weekday: 'short',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  const timePart = date.toLocaleTimeString('en-AU', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  return `${datePart} · ${timePart}`;
};

export const formatAppointmentDueDate = (isoStr: string): string => {
  const date = parseAppointmentDateTime(isoStr);
  if (!date) return '';

  return date.toLocaleDateString('en-AU', {
    weekday: 'short',
    day: 'numeric',
    month: 'long',
  });
};
